import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { css } from "@emotion/core"
import { Container, Row, Col } from "react-bootstrap"

export default () => {
  const data = useStaticQuery(graphql`
    query {
      oval: file(relativePath: { eq: "oval.png" }) {
        childImageSharp {
          fluid {
            base64
            aspectRatio
            sizes
            src
            srcSet
          }
        }
      }
    }
  `)
  return (
    <div className="webConst-process">
      <Container
        css={css`
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          text-align: center;
          position: relative;
        `}
        className="webConst-process-title"
      >
        核心业务
        <Row
          css={css`
            position: relative;
          `}
          className="webConst-process-content"
        >
          <div
            css={css`display: flex;
            width: 100%;
            }`}
          >
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;

                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                01
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                提出需求
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;

                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                02
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                需求分析
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;
                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                03
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                确定需求
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;

                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                04
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                签订合同
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
          </div>
          <div
            css={css`display: flex;
          width: 100%;
          }`}
            className="webConst-process-content-reverse"
          >
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;
                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                08
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                正式运行
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;

                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                07
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                人员培训
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;
                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                06
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                测试运行
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              css={css`
                position: relative;

                :hover {
                  div:nth-of-type(1) {
                    background: #f77920;
                  }
                  div:nth-of-type(2) {
                    opacity: 0.1;
                    color: #f77920;
                  }
                  div:nth-of-type(3) {
                    color: rgba(178, 187, 205, 1);
                    margin-top: -30px !important;
                  }
                  div:nth-of-type(4) {
                    display: block;
                  }
                }
              `}
              className="webConst-process-step"
            >
              <div
                css={css`
                  background: rgba(178, 189, 206, 1);
                `}
                className="webConst-process-step-dot"
              />
              <div
                css={css`
                  font-family: Brig;
                  color: rgba(243, 243, 243, 1);
                  text-align: left;
                `}
                className="webConst-process-step-serial"
              >
                05
              </div>
              <div
                css={css`
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(51, 51, 51, 1);
                  text-align: left;
                `}
                className="webConst-process-step-subtitle"
              >
                整体开发
              </div>
              <div
                css={css`
                  border: 3px solid #f77920;
                  position: absolute;
                  display: none;
                `}
                className="webConst-process-step-circle"
              />
            </Col>
          </div>
          <div
            css={css`
              width: 90%;
              height: 163px;
              position: absolute;
              top: 91px;
              left: 55px;
              z-index: -1;
              margin-bottom: 210px;
              background: url(${data.oval.childImageSharp.fluid.src}) center
                center;
              background-size: 100% 165px;
            `}
            className="webConst-process-tieku-circle"
          />
          <div
            css={css`
              height: 1px;
              background-color: rgba(243, 243, 243, 1);
              margin: 0 auto;
              position: absolute;
              z-index: -1;
            `}
            className="webConst-process-tieku-1"
          />
          <div
            css={css`
              height: 1px;
              background-color: rgba(243, 243, 243, 1);
              margin: 0 auto;
              position: absolute;
              z-index: -1;
            `}
            className="webConst-process-tieku-2"
          />
        </Row>
      </Container>
    </div>
  )
}
